import moment from "moment";

export class TeamTicker {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "TeamTicker";
    this.scene = "Team Ticker";
    this.data = [];
    this.page = 1;
  }

  preview({ options }) {
    if (options.start) {
      this.page = 1;
    }
    this.onAir = false;
    this.data = [];
    this.options = options;

    let team_type =
      options?.game?.home_team?._id === options.team?._id ? "home" : "away";

    let rows = '133233'
    this.data.push({
      name: "Title",
      value: {
        text:
          rows?.substring(1) || "",
      },
    });



    let count = 0;
    for (let i = 0; i < this.page - 1; i++) {
      count += parseInt(rows?.[i]);
    }

    new Array(5).fill(1).forEach((_, index) => {
      let row = index + 1;
      let player = {};

      let number_in_row =
        rows?.[this.page - 1];
      console.log("number in row", number_in_row);
      if (number_in_row > index) {
        console.log("player index", count + index + 1);
        player = options.squads?.find((s) => s.order === count + index + 1);
      }

      this.data.push({
        name: "First Name " + row,
        value: {
          text: player?.squad?.player?.first_name || "",
        },
      });
      this.data.push({
        name: "Last Name " + row,
        value: {
          text: player?.squad?.player?.last_name || "",
        },
      });
      this.data.push({
        name: "First Name Uppercase " + row,
        value: {
          text: player?.squad?.player?.first_name_upper || "",
        },
      });
      this.data.push({
        name: "Last Name Uppercase " + row,
        value: {
          text: player?.squad?.player?.last_name_upper || "",
        },
      });
      this.data.push({
        name: "Full Name " + row,
        value: {
          text:
            (player?.squad?.player?.first_name || "") +
            " " +
            (player?.squad?.player?.last_name || ""),
        },
      });
      this.data.push({
        name: "Full Name Uppercase" + row,
        value: {
          text:
            (player?.squad?.player?.first_name_upper || "") +
            " " +
            (player?.squad?.player?.last_name_upper || ""),
        },
      });
      this.data.push({
        name: "Captain " + row,
        value: {
          visible: player?.captain || false,
        },
      });
      this.data.push({
        name: "Position " + row,
        value: {
          text: player?.squad?.position || "",
        },
      });
      this.data.push({
        name: "Shirt Number " + row,
        value: {
          text: player?.squad?.shirt_number || "",
        },
      });
      this.data.push({
        name: "Nationality " + row,
        value: {
          text: player?.squad?.player?.nationality?.name || "",
        },
      });
      this.data.push({
        name: "Subbed " + row,
        value: {
          text: player?.subbed,
        },
      });

      let goal_text = "";
      let goals = [
        ...(options.game?.home_scorers?.filter(
          (g) => g.player === player?.squad?._id
        ) || []),
        ...(options.game?.away_scorers?.filter(
          (g) => g.player === player?.squad?._id
        ) || []),
      ]?.sort((a, b) => {
        return a.time - b.time;
      });
      goals?.map((goal, index) => {
        let time = moment.duration(goal.time);
        let minutes = time.minutes() + time.hours() * 60;
        let goalTime = "";
        // minutes += 1;
        if (
          goal.period === 2 &&
          minutes > (options?.game?.config?.half_duration || 45) * 2
        ) {
          goalTime =
            (options?.game?.config?.half_duration || 45) * 2 +
            "+" +
            (minutes - (options?.game?.config?.half_duration || 45) * 2);
        } else if (
          goal.period === 1 &&
          minutes > (options?.game?.config?.half_duration || 45)
        ) {
          goalTime =
            (options?.game?.config?.half_duration || 45) +
            "+" +
            (minutes - (options?.game?.config?.half_duration || 45));
        } else {
          goalTime = minutes;
        }

        let subtitle = "";
        if (goal.own_goal) {
          subtitle = "OG";
        } else if (goal.penalty) {
          subtitle = "P";
        }
        if (index > 0) {
          goal_text += " ";
        }
        goal_text += goalTime + "'";
        if (subtitle !== "") {
          goal_text += " " + subtitle;
        }
      });

      this.data.push({
        name: "Goals " + row,
        value: {
          text: goal_text,
        },
      });

      this.data.push({
        name: "Card " + row,
        value: {
          text:
            player?.dbl_yellow_card || player?.red_card
              ? "red"
              : player?.yellow_card
                ? "yellow"
                : "",
        },
      });
    });

    this.data.push({
      name: "Team Type",
      value: {
        text:
          options?.game?.home_team?._id === options.team?._id ? "home" : "away",
      },
    });
    this.data.push({
      name: "Team Code",
      value: {
        text: options.team?.code,
      },
    });

    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name,
      },
    });

    this.data.push({
      name: "Team Short Name",
      value: {
        text: options.team?.short_name,
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge,
      },
    });
    this.data.push({
      name: "Team Skyscraper Image",
      value: {
        image: "${user}" + options.team?.variables?.skyscraper,
      },
    });
    this.data.push({
      name: "Team Video Badge",
      value: {
        video: "${user}" + options.team?.variables?.video_badge,
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
    } else {
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;
    this.onAir_scene = this.scene;
    this.sendAnimate(this.scene, this.data);

    this.page++;
    this.options.start = false;
    this.preview({ options: this.options });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.onAir_scene, []);
    this.page = 1;
  }
}
